import type { FC } from "react"
import Link from "next/link"
import  "./error-page.css"
import Header from "../components/Header/Header"

interface ErrorPageProps {
  code: string | number
  message: string
  action?: {
    text: string
    onClick: () => void
  }
}

const ErrorPage: FC<ErrorPageProps> = ({ code, message, action }) => {
    return (
    <>
    <Header/>
    <div className="error-container">
      <div className="error-content">
        <h1 className="error-code">{code}</h1>
        <p className="error-message">{message}</p>
        {action && (
              <button onClick={action.onClick} className="error-button">
                {action.text}
              </button>
            )}
        <Link href="/" className="error-button">
          Go back to the home page
        </Link>
      </div>
    </div>
    </>
  )
}

export default ErrorPage

